module.exports = __webpack_public_path__ + "img/whatsapp.87284633.svg";